import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddFamily from './components/AddFamily';
import '../../styles/products.scss';

const FamilyCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer une Famille');
  }, [setTitle]);

  return (
    <div className="family-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddFamily />
        </Col>
      </Row>
    </div>
  );
};

export default FamilyCreate;
